import { Entity } from '@core/entities/entity'
import { RegisterTemplatePropertyType } from '@core/entities/register/RegisterTemplateProperty'
import { plainToInstance } from 'class-transformer'
import { IRegisterItemColumn } from '@core/entities/register/RegisterItemColumn/IRegisterItemColumn'
import { ApplyToType } from './IRegisterItemColumn'

export class RegisterItemColumn extends Entity<IRegisterItemColumn> {
  id: string

  type: RegisterTemplatePropertyType

  name: string

  required?: boolean

  isLinked?: boolean

  sortable?: boolean

  isDescription?: boolean

  isUsedForPreview?: boolean

  applyToType?: ApplyToType

  selectConfig?: Array<{
    uuid: string
    label: string
    key: string
    color: string
    colour: string
  }>

  checklistTemplates?: Array<{
    id: number
    name: string
  }>

  public isUniqueId(): boolean {
    return this.id === '0'
  }

  public static new(payload: unknown): RegisterItemColumn {
    const entity = plainToInstance(RegisterItemColumn, payload)

    return entity
  }
}
